import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Hexagon } from "lucide-react";

const ThreatIntel = () => {
  const [threats, setThreats] = useState([]);
  useEffect(() => { api.get("/threats").then(({ data }) => setThreats(data)); }, []);

  return (
    <div className="p-6 max-w-7xl">
      <PageHeader
        tag="Defence / Intel"
        title="Threat Intelligence"
        subtitle="Real-time aggregation of APTs, ransomware crews, and emerging TTPs relevant to your industry."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {threats.map((t) => {
          const col = t.severity === "critical" ? "rose" : "amber";
          return (
            <div key={t.id} data-testid={`threat-${t.name}`} className="csx-card p-4">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-slate-400">{t.category}</div>
                  <div className="font-display text-lg mt-1 text-slate-100">{t.name}</div>
                </div>
                <span className={`text-[10px] uppercase tracking-widest px-2 py-1 border border-${col}-500/60 text-${col}-300 bg-${col}-500/10`}>
                  {t.severity}
                </span>
              </div>
              <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
                <div>
                  <div className="text-[10px] uppercase tracking-widest text-slate-500">TTP</div>
                  <div className="font-mono text-cyan-300">{t.ttp}</div>
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-widest text-slate-500">Industry</div>
                  <div className="text-slate-300">{t.industry}</div>
                </div>
              </div>
              <div className="mt-3 pt-3 border-t border-slate-800 flex items-center justify-between text-[10px] text-slate-500 uppercase tracking-widest">
                <div className="flex items-center gap-1.5"><Hexagon className="h-3 w-3 text-fuchsia-400" /> First Seen</div>
                <span>{t.first_seen}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ThreatIntel;
